import React from 'react'

import { MOBILE_SCREEN_WIDTH } from '../../constants'
import useMedia from '../../hooks/useMedia'

import { useClosureHeader } from '../hooks'

import styles from './ClosureDetails.module.css'

const ClosureDetailsHeader = () => {
  const { clear, zoom, edit } = useClosureHeader()

  const isDesktop = useMedia(`(min-width: ${MOBILE_SCREEN_WIDTH}px)`)

  return (
    <div className={styles.header}>
      <div className={styles.headerButtonContainer}>
        {isDesktop && (
          <div className={styles.headerButton} onClick={edit}>
            <i className="fa fa-edit fa-2x"></i>
            <br />
            <span>Edit Closure</span>
          </div>
        )}
      </div>
      <div className={styles.headerButtonContainer}>
        <div className={styles.headerButton} onClick={zoom}>
          <i className="fa fa-crosshairs fa-2x"></i>
          <br />
          <span>Zoom To</span>
        </div>
      </div>
      <div className={styles.headerButtonContainer}>
        <div className={styles.headerButton} onClick={clear}>
          <i className="fa fa-sign-out-alt fa-2x"></i>
          <br />
          <span>Back to List</span>
        </div>
      </div>
    </div>
  )
}

export default ClosureDetailsHeader
